import { ReactNode, useEffect, useState } from "react";
import './index.css'
import { isIOS } from "react-device-detect";
import { useMyContext } from "../../entities/context";

interface IProps {
    setToast: Function;
    text: string | ReactNode;
    style?: React.CSSProperties;
    duration?: number;
}
const CustomToast = ({ setToast, text, style, duration = 1000 }: IProps) => {
    const { isGnbFooterHidden } = useMyContext();
    const [isLeaving, setIsLeaving] = useState(false);

    useEffect(() => {
        const showTimer = setTimeout(() => {
            setIsLeaving(true); // 애니메이션을 사라짐 방향으로
        }, duration);

        const hideTimer = setTimeout(() => {
            setToast(false); // 컴포넌트 제거
        }, duration + 200); // 사라지는 애니메이션 시간 만큼 더 줌

        return () => {
            clearTimeout(showTimer);
            clearTimeout(hideTimer);
        };
    }, [setToast, duration]);

    return (
        <div style={{ display: "flex", justifyContent: "center" }}>
            <div className={isLeaving ? "slide-out-bottom" : "slide-in-bottom"} style={{ maxWidth: "432px", width: "90%", borderRadius: "var(--radius4)", paddingBlock: "var(--space12)", backgroundColor: '#000000B2', color: "#FFFFFF", position: "fixed", zIndex: 4, bottom: (isGnbFooterHidden ? 0 : (isIOS ? 20 : 0) + 72) + (isIOS ? 34 : 20), ...style }}>
                <div className="body/b2" style={{ whiteSpace: "pre-wrap", textAlign: "center" }}>{text}</div>
            </div>
        </div>
    );
}

export { CustomToast };